/**
 * Tingkat antara in the app (release 16): the diocese's word for the level between it and its
 * parishes, fixed by the build in VITE_SATU_TINGKAT_ANTARA: that variable, else the API's
 * SATU_TINGKAT_ANTARA (vite.config.ts, review M4). Wilayah with its Ketua Wilayah when unset,
 * Dekenat with its Dekan for `dekenat`. A build with any other value reads wilayah;
 * vite.config.ts warns about it, or about the two differing, once in the build log.
 *
 * Read once when the module loads, in the page and in the worker alike: the value is fixed for
 * the build. A screen fills its strings with `teksTingkat` (with `isiUnit` where they also name
 * the parish's unit), shared functions take `SEBUTAN_TINGKAT`. Pure: no DOM, no database.
 */
import { isiTingkat, type SebutanTingkat, sebutanTingkat } from '@satu/shared'

// `?.`: the e2e specs import screen modules under Playwright's Node, where Vite has not given
// `import.meta` its `env` (the default word then stands).
export const SEBUTAN_TINGKAT: SebutanTingkat = sebutanTingkat(
  import.meta.env?.VITE_SATU_TINGKAT_ANTARA,
)

/** `teks` (a string or a part of the strings) in the build's word; the same object each call. */
export function teksTingkat<T>(teks: T): T {
  return isiTingkat(teks, SEBUTAN_TINGKAT)
}
